import React, { useContext, useEffect, useState } from 'react';
import VehiclePagecard2 from '../../components/Cards/VehiclePagecard2';
import Driverbehavior from '../../components/Cards/Driverbehavior';
import Fueleff from '../../components/Cards/Fueleff';
import Substable from '../../components/Table/substable';
import Moresubstable from '../../components/Table/Moresubtable';
import VehiclePagecard3 from '../../components/Cards/VehiclePagecard3';
import Fleetindex from './Fleetedgeindex';
import Piechart from '../../components/Graph/Piechart';
import mousepointer from "../../assets/images/mouse_hand.png"
import BasicModal from '../../components/Modals/BasicModal';
import Drivertraining from './Drivertraining';
import Driverindex from './Driverindex';
import { DriverDetails, Drivertraninggiven } from './Drivertraiingkpi';
import { FilterContext } from '../../context/Filter';
import Psfaccordian from '../../components/ChildData/Psfaccordian';
import VehiclePagecard5 from '../../components/Cards/Vehiclepage5';
import NavButtons from '../../components/NevBar/NavButtons';
import Header from '../../components/Header/Header';
import CustomerMetricsAccordian from '../../components/psfSalesService/CustomerMetricsAccordian';
import WaterMark from '../../components/WaterMark';

// import Fleetindex from '../FleetEdge';

const Fleetedge = () => {
    const [openTrainingDetailsModal, setTrainingDetailsModal] = useState(false);
    const [driverdata, setDriverdata] = useState([]);
    const [trainingdata, setTrainingData] = useState([]);

    const { superArn: parArn, childArn } = useContext(FilterContext);
    const key = childArn ? "childArn" : "parArn";
    const value = childArn || parArn;
    const payload = { [key]: value };


    const openTrainingModal = () => {
        setTrainingDetailsModal(true)
    }
    const closeTrainingModal = () => {
        setTrainingDetailsModal(false)
    }


    const fetchDriverDetail = async () => {
        try {
            const data2 = await DriverDetails(payload);
            setDriverdata(data2);
        } catch (error) {
            console.error("Driver details fetch error:", error);
        }
    };

    const fetchdrivertraninggiven = async () => {
        try {
            const data3 = await Drivertraninggiven(payload);
            setTrainingData(data3);
        } catch (error) {
            console.error("Training data fetch error:", error);
        }
    };

    useEffect(() => {
        window.scrollTo(0, 0);


        fetchDriverDetail();
        fetchdrivertraninggiven();
    }, []);


    return (
        <div>
            <WaterMark />
            <Header heading={"FleetEdge"} />
            <div className='flex-col justify-center justify-items-center m-1  gap-2 '>
                <div className="mt-1 w-full mb-2">
                    <CustomerMetricsAccordian />
                </div>
                <div className='block md:grid grid-cols-2 w-full gap-1 m-2 '>
                    <VehiclePagecard5 heading={"Subscription Details"} des={<Substable />} />
                    <VehiclePagecard5 heading={"Driving Behavior Cluster"} des={<Driverbehavior />} />
                </div>
                <div className='block md:grid grid-cols-2 w-full gap-2 mt-2'>

                    <VehiclePagecard5 heading={"Fuel Efficiency Cluster"} des={<Fueleff />} />
                    <VehiclePagecard5
                        heading={"Driver Training"}
                        trigger={<img src={mousepointer} alt="open modal" />}
                        open={openTrainingDetailsModal}
                        handleOpenModal={openTrainingModal}
                        handleCloseModal={closeTrainingModal}
                        des={<Driverindex />}
                        modalContent={< Drivertraining data={driverdata} />}   // 👈 goes inside modal
                    />

                </div>
                <div className='  w-96 md:w-full'>
                    <VehiclePagecard3 heading={"More Subscription Details"} des={<Moresubstable />} heading1={"FleetEdge"} des1={<Fleetindex />} />
                </div>

                <NavButtons />
            </div>

        </div>
    );
};

export default Fleetedge;
